import axios from "axios";
import { getToken } from "../session";

const DELETE = async (endpoint) => {
  const response = await axios.delete(endpoint, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response;
};

export default DELETE;
